<template>
  <!-- Round-3 shared (#164): MT customer / trading-partner company detail.
       Pass a resolved :company object, OR :company-id to auto-fetch. -->
  <el-dialog
    :title="$t('mt_shared.customer_detail')"
    :visible.sync="innerVisible"
    width="560px"
    append-to-body
    @opened="onOpened"
  >
    <div v-loading="loading">
      <div v-if="data" class="mt-cust-detail">
        <h4 class="mb-3">{{ data.name || "-" }}</h4>
        <dl class="row mb-0">
          <dt class="col-5 text-muted">{{ $t('mt_shared.tax_id') }}</dt>
          <dd class="col-7">
            {{ data.tax_id || "-" }}
            <span v-if="data.branch_code" class="text-muted ml-1">({{ data.branch_code }})</span>
          </dd>

          <dt class="col-5 text-muted">{{ $t('mt_shared.branch_code') }}</dt>
          <dd class="col-7">{{ data.branch_code || "-" }}</dd>

          <dt class="col-5 text-muted">{{ $t('mt_shared.address') }}</dt>
          <dd class="col-7" style="white-space: pre-line">{{ data.address || "-" }}</dd>

          <dt class="col-5 text-muted">{{ $t('mt_shared.contact_name') }}</dt>
          <dd class="col-7">{{ data.contact_name || "-" }}</dd>

          <dt class="col-5 text-muted">{{ $t('mt_shared.contact_phone') }}</dt>
          <dd class="col-7">{{ data.contact_phone || "-" }}</dd>

          <dt class="col-5 text-muted">{{ $t('mt_shared.contact_email') }}</dt>
          <dd class="col-7">{{ data.contact_email || "-" }}</dd>

          <dt class="col-5 text-muted">{{ $t('mt_shared.credit_term_days') }}</dt>
          <dd class="col-7">
            {{ hasVal(data.credit_term_days) ? data.credit_term_days + " " + $t('mt_shared.days') : "-" }}
          </dd>

          <dt class="col-5 text-muted">{{ $t('mt_shared.gp_percent') }}</dt>
          <dd class="col-7">
            {{ hasVal(data.gp_percent) ? Number(data.gp_percent).toFixed(2) + " %" : "-" }}
          </dd>

          <dt class="col-5 text-muted">{{ $t('mt_shared.vat_included') }}</dt>
          <dd class="col-7">
            {{ Number(data.vat_included) ? $t('mt_shared.yes') : $t('mt_shared.no') }}
          </dd>
        </dl>
      </div>
      <div v-else-if="!loading" class="text-muted text-center py-3">
        {{ $t('mt_shared.no_data') }}
      </div>
    </div>

    <span slot="footer">
      <el-button @click="innerVisible = false">{{ $t('mt_shared.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { Dialog, Button, Loading } from "element-ui";
import { ModernTradeService } from "@/resource";

export default {
  name: "CustomerDetailModal",
  components: {
    [Dialog.name]: Dialog,
    [Button.name]: Button,
  },
  directives: {
    loading: Loading.directive,
  },
  props: {
    visible: { type: Boolean, default: false },
    // Pre-resolved company object (skips the fetch when provided).
    company: { type: Object, default: null },
    // When only an id is known, the modal fetches on open.
    companyId: { type: [Number, String], default: null },
  },
  data() {
    return {
      innerVisible: this.visible,
      loading: false,
      fetched: null,
    };
  },
  computed: {
    data() {
      return this.company || this.fetched;
    },
  },
  watch: {
    visible(v) {
      this.innerVisible = v;
    },
    innerVisible(v) {
      this.$emit("update:visible", v);
    },
  },
  methods: {
    hasVal(v) {
      return v !== undefined && v !== null && v !== "";
    },
    async onOpened() {
      // Only fetch when caller didn't pass a full object.
      if (this.company || !this.companyId) return;
      this.loading = true;
      try {
        const res = await ModernTradeService.companyGet(this.companyId);
        const d = (res.data && res.data.Data && res.data.Data[0]) || {};
        this.fetched = d.company || d.item || d;
      } catch (e) {
        this.fetched = null;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
